// Default 24-hour HH:mm delivery time used when seeding the subscribe form
// and when an edit-mode subscription comes back without a timeOfDay.
export const DefaultDeliveryTime = "07:00";
